import React, { Component } from 'react';
import { Select, Typography, Radio, Button, Switch, message } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  dropDownSearchJiraProjects,
  channelAdminConfig,
  getProject,
  searchJiraProjects,
  updateSkill,
} from '../skills_action';
import queryString from 'query-string';

const { Option } = Select;
const { Text } = Typography;

class ProjectRestriction extends Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.state = {
      editMode: false,
      // picker opened by the switch while no project is saved; the switch stays off
      pending: false,
      server_type: null,
      projectRestriction: { ...this.initialProjectRestriction },
    };
  }

  initialProjectRestriction = {
    projectRestrictionDisabled: true,
    restriction_type: 'block',
    selected_projects: [],
  };

  // A channel restriction turned on with no projects is ambiguous (restrict
  // nothing vs block everything), so it never counts as on.
  hasProjects = (pr) =>
    !!(pr && pr.selected_projects && pr.selected_projects.length > 0);

  savedChannelRestriction = (pr) =>
    pr && !pr.projectRestrictionDisabled && !this.hasProjects(pr)
      ? { ...pr, projectRestrictionDisabled: true }
      : pr;

  componentDidMount() {
    const { commonChanneldata, jiraSkill } = this.props;
    const { sub_skill } = this.props.match.params;

    if (this.props.isGlobalProjectRestriction) {
      // this.getRequiredData();
      if (
        jiraSkill &&
        jiraSkill.skill_metadata &&
        (sub_skill === 'jira_service_desk'
          ? jiraSkill.skill_metadata.globalJSDProjectRestriction
          : jiraSkill.skill_metadata.globalSoftwareProjectRestriction)
      )
        this.setState({
          projectRestriction:
            sub_skill === 'jira_service_desk'
              ? jiraSkill.skill_metadata.globalJSDProjectRestriction
              : jiraSkill.skill_metadata.globalSoftwareProjectRestriction,
        });
    } else {
      const channelFound = commonChanneldata.find(
        (data) =>
          data.channel_id ===
          queryString.parse(window.location.search).channel_id
      );
      if (channelFound && channelFound.projectRestriction)
        this.setState({
          projectRestriction: this.savedChannelRestriction(
            channelFound.projectRestriction
          ),
        });
    }
  }

  componentDidUpdate(prevProps) {
    const { commonChanneldata, jiraSkill, isGlobalProjectRestriction } =
      this.props;
    const { sub_skill } = this.props.match.params;

    if (
      prevProps.match.params.sub_skill !== this.props.match.params.sub_skill
    ) {
      this.setState({ editMode: false });
      // if (this.props.match.params.sub_skill === "jira_software") this.getRequiredData();

      if (isGlobalProjectRestriction && jiraSkill && jiraSkill.skill_metadata)
        this.setState({
          projectRestriction:
            sub_skill === 'jira_service_desk'
              ? jiraSkill.skill_metadata.globalJSDProjectRestriction ||
                this.initialProjectRestriction
              : jiraSkill.skill_metadata.globalSoftwareProjectRestriction ||
                this.initialProjectRestriction,
        });
    }

    if (this.props.projectLoading !== prevProps.projectLoading) {
      if (this.props.projectLoading === false)
        this.getMissingProjects({ projects: this.props.projects });
    }
  }

  // getRequiredData = () => {
  //   const { jiraSkill } = this.props;
  //   if (jiraSkill && jiraSkill.skill_metadata.metadata && jiraSkill.skill_metadata.metadata.server_type) {
  //     this.setState({ server_type: jiraSkill.skill_metadata.metadata.server_type }, () => {
  //       if (this.state.server_type === "jira_server_oauth" || this.state.server_type === "jira_server") {
  //         this.props.getProject(this.props.match.params.wId).then((res) => this.setState({ projectLoading: false }));
  //       } else {
  //         this.props.searchJiraProjects(this.props.match.params.wId, /* "?query=typeKey=software,business" */ '').then((res) => {
  //           if (res.data.success && res.data.projectsData && res.data.projectsData.values) {
  //             this.getMissingProjects({ projects: res.data.projectsData.values });
  //           }
  //         });
  //       }
  //     });
  //   }
  // };

  getMissingProjects = ({ projects }) => {
    const { jiraSkill, isGlobalProjectRestriction } = this.props;
    let unavailableProjects = [];

    if (
      projects &&
      projects.length > 0 &&
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.globalSoftwareProjectRestriction &&
      jiraSkill.skill_metadata.globalSoftwareProjectRestriction
        .selected_projects
    ) {
      const selected_projects =
        jiraSkill.skill_metadata.globalSoftwareProjectRestriction
          .selected_projects;
      selected_projects.forEach((selected_project) => {
        if (!projects.find((project) => project.id === selected_project.id))
          unavailableProjects.push(selected_project);
      });
    }

    if (unavailableProjects.length > 0) {
      unavailableProjects.forEach((p) => {
        const query = `id=${p.id}`;
        this.props.dropDownSearchJiraProjects(
          this.props.match.params.wId,
          `?query=${query}`
        );
      });
    }
  };

  onSearch = (val) => {
    const { channel_type } = queryString.parse(window.location.search);
    const { isGlobalProjectRestriction } = this.props;
    if (
      this.props.currentSkill &&
      this.props.currentSkill.metadata &&
      (this.props.currentSkill.metadata.server_type === 'jira_cloud_oauth' ||
        this.props.currentSkill.metadata.server_type === 'jira_cloud') &&
      this.props.match.params.sub_skill !== 'jira_service_desk'
    ) {
      let query = `query=${val || ''}`;
      const queryType = isGlobalProjectRestriction
        ? ''
        : channel_type === 'agent'
        ? '&typeKey=service_desk'
        : '&typeKey=software,business';
      query = query + queryType;
      if (
        isGlobalProjectRestriction
          ? true
          : channel_type === 'project' || channel_type === 'agent'
      ) {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.props.dropDownSearchJiraProjects(
            this.props.match.params.wId,
            `?query=${query}`
          );
        }, 300);
      }
    }
  };

  handleSwitch = (checked) => {
    const { projectRestriction } = this.state;
    // A channel restriction with no saved projects refuses to turn on: open
    // the picker instead, and Save turns it on once a project is chosen.
    if (
      checked &&
      !this.props.isGlobalProjectRestriction &&
      !this.hasProjects(projectRestriction)
    ) {
      this.setState({ pending: true, editMode: true });
      return;
    }
    let temp = { ...projectRestriction };
    temp.projectRestrictionDisabled = !checked;
    this.setState({ projectRestriction: temp }, () =>
      this.updateData('switch')
    );
  };

  handleChange = ({ type, value, options }) => {
    // console.log(options);
    const { projectRestriction } = this.state;
    let temp = { ...projectRestriction };
    // if (type === "switch") temp.projectRestrictionDisabled = !value;
    if (type === 'radio') {
      temp.restriction_type = value;
      temp.selected_projects = [];
    } else if (type === 'select') {
      temp.selected_projects = options.map((o) => o.project);
      temp.selected_projects = temp.selected_projects.filter(function (
        element
      ) {
        return element !== undefined;
      });
    }
    this.setState({ projectRestriction: temp });
  };

  handleSave = () => {
    const { projectRestriction, pending } = this.state;
    if (pending)
      this.setState(
        {
          projectRestriction: {
            ...projectRestriction,
            projectRestrictionDisabled: false,
          },
        },
        () => this.updateData()
      );
    else this.updateData();
  };

  updateData = (from) => {
    const { isGlobalProjectRestriction } = this.props;
    const { projectRestriction } = this.state;
    const { sub_skill } = this.props.match.params;

    const queryParams = queryString.parse(this.props.location.search);
    if (from !== 'switch') this.setState({ apiLoading: true });
    //checking if it's enterprice shared channel or not
    const channelFound = isGlobalProjectRestriction
      ? false
      : this.props.userChannels.find(
          (cha) => cha.id === queryParams.channel_id
        );
    let isGridSharedChannel = false;
    if (
      channelFound &&
      channelFound.is_org_shared &&
      channelFound.enterprise_id
    ) {
      isGridSharedChannel = true;
      this.setState({ isGridSharedChannel: true });
    }

    if (isGlobalProjectRestriction) {
      let data =
        sub_skill === 'jira_service_desk'
          ? { globalJSDProjectRestriction: projectRestriction }
          : { globalSoftwareProjectRestriction: projectRestriction };

      this.props
        .updateSkill(
          this.props.match.params.skill_id,
          this.props.match.params.wId,
          data
        )
        .then((res) => {
          if (res.data.success) {
            if (from !== 'switch') {
              message.success('Project restrictions updated!');
              this.setState({ apiLoading: false, editMode: false });
            }
            this.setState({
              projectRestriction:
                sub_skill === 'jira_service_desk'
                  ? res.data.skill.globalJSDProjectRestriction
                  : res.data.skill.globalSoftwareProjectRestriction,
            });
          }
        });
    } else {
      this.props
        .channelAdminConfig(
          this.props.match.params.wId,
          this.props.match.params.skill_id,
          queryParams.channel_id,
          {
            channel: {
              id: queryParams.channel_id,
              name: queryParams.channel_name,
            },
            projectRestriction: this.state.projectRestriction,
            ...queryParams,
          },
          isGridSharedChannel
        )
        .then((res) => {
          if (res.data.success) {
            if (from !== 'switch') {
              message.success('Project restrictions updated!');
              this.setState({
                apiLoading: false,
                editMode: false,
                pending: false,
              });
            }
            this.setState({
              projectRestriction: res.data.channelCommonData.projectRestriction,
            });
          }
        });
    }
  };

  handleCancel = () => {
    const { commonChanneldata, isGlobalProjectRestriction, jiraSkill } =
      this.props;
    const { sub_skill } = this.props.match.params;
    if (isGlobalProjectRestriction) {
      if (
        jiraSkill &&
        (sub_skill === 'jira_service_desk'
          ? jiraSkill.skill_metadata.globalJSDProjectRestriction
          : jiraSkill.skill_metadata.globalSoftwareProjectRestriction)
      ) {
        this.setState({
          projectRestriction:
            sub_skill === 'jira_service_desk'
              ? jiraSkill.skill_metadata.globalJSDProjectRestriction
              : jiraSkill.skill_metadata.globalSoftwareProjectRestriction,
        });
      } else
        this.setState({ projectRestriction: this.initialProjectRestriction });
    } else {
      const channelFound = commonChanneldata.find(
        (data) =>
          data.channel_id ===
          queryString.parse(window.location.search).channel_id
      );
      if (channelFound && channelFound.projectRestriction)
        this.setState({
          projectRestriction: this.savedChannelRestriction(
            channelFound.projectRestriction
          ),
        });
      else
        this.setState({ projectRestriction: this.initialProjectRestriction });
    }
    this.setState({ editMode: false, pending: false });
  };

  render() {
    const { channel_type, channel_id } = queryString.parse(
      this.props.location.search
    );
    const {
      projects,
      isChannelAdmin,
      channelDefault,
      isWorkspaceAdmin,
      isGlobalProjectRestriction,
      jiraSkill,
    } = this.props;
    const { projectRestriction, editMode, apiLoading, pending } = this.state;
    let disabled = !editMode;
    let actionDisabled = !isWorkspaceAdmin && !isChannelAdmin;
    const noProjects =
      !isGlobalProjectRestriction && !this.hasProjects(projectRestriction);
    let children = (
      isGlobalProjectRestriction
        ? projects /* already getting the service desk projects in request type restriction */
        : channel_type === 'support'
        ? projects
        : channel_type === 'agent'
        ? projects.filter((proj) => proj.projectTypeKey === 'service_desk')
        : projects.filter(
            (proj) =>
              proj.projectTypeKey === 'software' ||
              proj.projectTypeKey === 'business'
          )
    ).map((d) => {
      let disabled = false;

      if (isGlobalProjectRestriction) {
        if (
          this.props.match.params.sub_skill === 'jira_service_desk' &&
          jiraSkill &&
          jiraSkill.skill_metadata &&
          jiraSkill.skill_metadata.globalDefaults &&
          jiraSkill.skill_metadata.globalDefaults.ticketDefaults
        ) {
          if (
            jiraSkill.skill_metadata.globalDefaults.ticketDefaults
              .defaultProject.id ===
            d.id /* || jiraSkill.skill_metadata.globalDefaults.ticketDefaults.defaultProject.project_id === d.projectId */
          )
            disabled = true;
        } else if (
          this.props.match.params.sub_skill === 'jira_software' &&
          jiraSkill &&
          jiraSkill.skill_metadata &&
          jiraSkill.skill_metadata.globalDefaults &&
          jiraSkill.skill_metadata.globalDefaults.issueDefaults
        ) {
          if (
            jiraSkill.skill_metadata.globalDefaults.issueDefaults.defaultProject
              .id === d.id
          )
            disabled = true;
        }
      } else {
        if (channelDefault && channelDefault.channel_id === channel_id)
          if (
            channelDefault.link_info &&
            (channelDefault.link_info.project_id === d.id ||
              channelDefault.link_info.project_id === d.projectId) &&
            projectRestriction &&
            projectRestriction.restriction_type === 'block'
          )
            disabled = true;
      }
      return (
        <Option
          key={d.key || d.projectKey}
          value={d.id || d.projectId}
          name={d.name || d.projectName}
          project={d}
          disabled={disabled}
        >
          {`${d.name || d.projectName} ${`(${d.key || d.projectKey})`}`}
        </Option>
      );
    });
    // console.log(children);
    children = children.filter((child) => {
      if (this.props.match.params.sub_skill === 'jira_software') {
        return (
          child.props.project.projectTypeKey === 'software' ||
          child.props.project.projectTypeKey === 'business'
        );
      } else if (this.props.match.params.sub_skill === 'jira_service_desk') {
        return child;
      }
    });
    // console.log(children);
    return (
      <>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: 8,
          }}
        >
          <div>
            <Text>
              <strong>
                {isGlobalProjectRestriction
                  ? 'Guest project restrictions: '
                  : 'Project restrictions: '}
              </strong>
            </Text>
            <Text type='secondary'>
              {isGlobalProjectRestriction ? (
                'Allow or block projects for use by guests'
              ) : (
                <>
                  Limit access to projects when creating{' '}
                  {channel_type === 'support' ? 'request' : 'issue'} in this
                  channel
                </>
              )}
            </Text>
          </div>
          <div>
            <Switch
              checked={!projectRestriction.projectRestrictionDisabled}
              onChange={(checked, e) => {
                e.stopPropagation();
                this.handleSwitch(checked);
              }}
              disabled={actionDisabled}
            />
          </div>
        </div>
        {!projectRestriction.projectRestrictionDisabled || pending ? (
          <>
            <div style={{ marginBottom: 16 }}>
              <div style={{ marginBottom: 8 }}>
                <Radio.Group
                  disabled={disabled}
                  value={projectRestriction.restriction_type}
                  onChange={(e) =>
                    this.handleChange({ type: 'radio', value: e.target.value })
                  }
                >
                  <Radio value={'block'}>
                    <Text type='secondary'>Block project(s)</Text>
                  </Radio>
                  <Radio value={'allow'}>
                    <Text type='secondary'>Allow project(s)</Text>
                  </Radio>
                </Radio.Group>
              </div>
              <div>
                <Select
                  style={{ width: '81%' }}
                  mode='multiple'
                  showSearch
                  autoClearSearchValue
                  placeholder='Select projects'
                  onSearch={this.onSearch}
                  onChange={(value, options) =>
                    this.handleChange({ type: 'select', value, options })
                  }
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={[
                    ...projectRestriction.selected_projects.map(
                      (p) => p && (p.id || p.projectId)
                    ),
                  ]}
                  disabled={disabled}
                  allowClear
                  loading={projects && projects.length === 0}
                >
                  {children}
                </Select>
                {editMode && noProjects && (
                  <div style={{ marginTop: 4 }}>
                    <Text type='secondary'>
                      {pending
                        ? 'Select at least one project and save to turn on restrictions.'
                        : 'Select at least one project to save.'}
                    </Text>
                  </div>
                )}
              </div>
            </div>
            <div>
              {!actionDisabled && (
                <>
                  {editMode ? (
                    <>
                      <Button
                        type='primary'
                        loading={apiLoading}
                        disabled={noProjects}
                        onClick={() => this.handleSave()}
                        style={{ width: 100 }}
                      >
                        Save
                      </Button>
                      <Button
                        style={{ width: 100, marginLeft: 16 }}
                        onClick={() => this.handleCancel()}
                      >
                        Cancel
                      </Button>
                    </>
                  ) : (
                    <Button
                      style={{ width: 100 }}
                      onClick={() => this.setState({ editMode: true })}
                    >
                      Edit
                    </Button>
                  )}
                </>
              )}
            </div>
          </>
        ) : (
          ''
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    projects: state.skills.projects,
    currentSkill: state.skills.currentSkill,
    commonChanneldata: state.skills.commonChanneldata,
    channelDefault: state.skills.channelDefault,
    isWorkspaceAdmin: state.common_reducer.isAdmin,
    jiraSkill: state.skills.skills
      ? state.skills.skills.find((skill) => skill.key === 'jira')
      : null,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    dropDownSearchJiraProjects,
    channelAdminConfig,
    searchJiraProjects,
    getProject,
    updateSkill,
  })(ProjectRestriction)
);
